<template>
  <div class="content-item flex">
    <div class="content-item-label"><span class="red">*</span>敏感词</div>
    <el-input
      :rows="1"
      resize="none"
      disabled=""
      type="textarea"
      class="item-input sensitiveWords"
      placeholder="暂无"
      v-model="input"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "sensitiveWords",
  props: ["sensitiveWords"],
  computed: {
    input: {
      get() {
        return this.sensitiveWords;
      },
      set(val) {
        this.$emit("update:sensitiveWords", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.sensitiveWords {
  :deep(.el-textarea__inner) {
    min-height: 30px !important;
    resize: none;
  }
}
</style>
